class KeyFlowVO {
  data: any;

  constructor(data: any) {
    this.data = data;
  }

  static mapping(data: any) {
    return new this(data);
  }
}

export default KeyFlowVO;
